import { Select } from "antd";
import React from "react";

import { RejectIcon } from "@/Components/Icons/RejectIcon";
import { SelectDownIcon } from "@/Components/Icons/SelectDownIcon";
import { milesList } from "@/Constants/filterConstants";

/**
 * Creates a MilesFilter component with a list of miles data to be selected.
 *
 * @param {Object} value - the current selected value
 * @param {Function} handleChange - the function to handle changes in selection
 * @return {JSX.Element} the MilesFilter component
 */
const MilesFilter = ({ value, handleChange }) => {
  return (
    <div className="candidateRole_MilesFilter_Wrapper grid gap-3">
      <label className="label font-normal text-black" htmlFor="miles">
        Select Miles
      </label>
      <Select
        showSearch
        style={{ width: "100%" }}
        placeholder="Select Miles"
        optionFilterProp="children"
        className="ease min-h-[40px] w-full overflow-hidden rounded-lg border border-lightGrey text-[14px] font-medium leading-[normal] text-black transition-all duration-200 focus:border-primary"
        suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
        onChange={(value) => {
          handleChange(value);
        }}
        allowClear={{
          clearIcon: <RejectIcon cls="w-[20px] h-[20px] text-red" />,
        }}
        value={value}
      >
        {milesList.map((item, index) => {
          const { value, name, cls } = item;
          return (
            <Select.Option value={value} key={index} className={`${cls}`}>
              {name}
            </Select.Option>
          );
        })}
      </Select>
    </div>
  );
};

export default MilesFilter;
